import { EnvVariablesContext, EnvVariablesProvider } from '@dcl-ue/tools';
import React, { useState, useContext, useEffect } from 'react';
import { getRecaptchaToken, recaptchaAuthFetch } from '@tr-digital/fetch';

global.emcmUiConfig = {
  styles: {
    namespace: "tr"
  }
};

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = /*#__PURE__*/createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var runtime = function (exports) {

    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var undefined$1; // More compressible than void 0.

    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

    function define(obj, key, value) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
      return obj[key];
    }

    try {
      // IE 8 has a broken Object.defineProperty that only works on DOM objects.
      define({}, "");
    } catch (err) {
      define = function define(obj, key, value) {
        return obj[key] = value;
      };
    }

    function wrap(innerFn, outerFn, self, tryLocsList) {
      // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
      var generator = Object.create(protoGenerator.prototype);
      var context = new Context(tryLocsList || []); // The ._invoke method unifies the implementations of the .next,
      // .throw, and .return methods.

      generator._invoke = makeInvokeMethod(innerFn, self, context);
      return generator;
    }

    exports.wrap = wrap; // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.

    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }

    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed"; // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.

    var ContinueSentinel = {}; // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.

    function Generator() {}

    function GeneratorFunction() {}

    function GeneratorFunctionPrototype() {} // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.


    var IteratorPrototype = {};

    IteratorPrototype[iteratorSymbol] = function () {
      return this;
    };

    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));

    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
      // This environment has a native %IteratorPrototype%; use it instead
      // of the polyfill.
      IteratorPrototype = NativeIteratorPrototype;
    }

    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
    GeneratorFunctionPrototype.constructor = GeneratorFunction;
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"); // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.

    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        define(prototype, method, function (arg) {
          return this._invoke(method, arg);
        });
      });
    }

    exports.isGeneratorFunction = function (genFun) {
      var ctor = typeof genFun === "function" && genFun.constructor;
      return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
      // do is to check its .name property.
      (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };

    exports.mark = function (genFun) {
      if (Object.setPrototypeOf) {
        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
      } else {
        genFun.__proto__ = GeneratorFunctionPrototype;
        define(genFun, toStringTagSymbol, "GeneratorFunction");
      }

      genFun.prototype = Object.create(Gp);
      return genFun;
    }; // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.


    exports.awrap = function (arg) {
      return {
        __await: arg
      };
    };

    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);

        if (record.type === "throw") {
          reject(record.arg);
        } else {
          var result = record.arg;
          var value = result.value;

          if (value && typeof value === "object" && hasOwn.call(value, "__await")) {
            return PromiseImpl.resolve(value.__await).then(function (value) {
              invoke("next", value, resolve, reject);
            }, function (err) {
              invoke("throw", err, resolve, reject);
            });
          }

          return PromiseImpl.resolve(value).then(function (unwrapped) {
            // When a yielded Promise is resolved, its final value becomes
            // the .value of the Promise<{value,done}> result for the
            // current iteration.
            result.value = unwrapped;
            resolve(result);
          }, function (error) {
            // If a rejected Promise was yielded, throw the rejection back
            // into the async generator function so it can be handled there.
            return invoke("throw", error, resolve, reject);
          });
        }
      }

      var previousPromise;

      function enqueue(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }

        return previousPromise = // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
        // invocations of the iterator.
        callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      } // Define the unified helper method that is used to implement .next,
      // .throw, and .return (see defineIteratorMethods).


      this._invoke = enqueue;
    }

    defineIteratorMethods(AsyncIterator.prototype);

    AsyncIterator.prototype[asyncIteratorSymbol] = function () {
      return this;
    };

    exports.AsyncIterator = AsyncIterator; // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.

    exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
      if (PromiseImpl === void 0) PromiseImpl = Promise;
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    };

    function makeInvokeMethod(innerFn, self, context) {
      var state = GenStateSuspendedStart;
      return function invoke(method, arg) {
        if (state === GenStateExecuting) {
          throw new Error("Generator is already running");
        }

        if (state === GenStateCompleted) {
          if (method === "throw") {
            throw arg;
          } // Be forgiving, per 25.3.3.3.3 of the spec:
          // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume


          return doneResult();
        }

        context.method = method;
        context.arg = arg;

        while (true) {
          var delegate = context.delegate;

          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);

            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }

          if (context.method === "next") {
            // Setting context._sent for legacy support of Babel's
            // function.sent implementation.
            context.sent = context._sent = context.arg;
          } else if (context.method === "throw") {
            if (state === GenStateSuspendedStart) {
              state = GenStateCompleted;
              throw context.arg;
            }

            context.dispatchException(context.arg);
          } else if (context.method === "return") {
            context.abrupt("return", context.arg);
          }

          state = GenStateExecuting;
          var record = tryCatch(innerFn, self, context);

          if (record.type === "normal") {
            // If an exception is thrown from innerFn, we leave state ===
            // GenStateExecuting and loop back for another invocation.
            state = context.done ? GenStateCompleted : GenStateSuspendedYield;

            if (record.arg === ContinueSentinel) {
              continue;
            }

            return {
              value: record.arg,
              done: context.done
            };
          } else if (record.type === "throw") {
            state = GenStateCompleted; // Dispatch the exception by looping back around to the
            // context.dispatchException(context.arg) call above.

            context.method = "throw";
            context.arg = record.arg;
          }
        }
      };
    } // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.


    function maybeInvokeDelegate(delegate, context) {
      var method = delegate.iterator[context.method];

      if (method === undefined$1) {
        // A .throw or .return when the delegate iterator has no .throw
        // method always terminates the yield* loop.
        context.delegate = null;

        if (context.method === "throw") {
          // Note: ["return"] must be used for ES3 parsing compatibility.
          if (delegate.iterator["return"]) {
            // If the delegate iterator has a return method, give it a
            // chance to clean up.
            context.method = "return";
            context.arg = undefined$1;
            maybeInvokeDelegate(delegate, context);

            if (context.method === "throw") {
              // If maybeInvokeDelegate(context) changed context.method from
              // "return" to "throw", let that override the TypeError below.
              return ContinueSentinel;
            }
          }

          context.method = "throw";
          context.arg = new TypeError("The iterator does not provide a 'throw' method");
        }

        return ContinueSentinel;
      }

      var record = tryCatch(method, delegate.iterator, context.arg);

      if (record.type === "throw") {
        context.method = "throw";
        context.arg = record.arg;
        context.delegate = null;
        return ContinueSentinel;
      }

      var info = record.arg;

      if (!info) {
        context.method = "throw";
        context.arg = new TypeError("iterator result is not an object");
        context.delegate = null;
        return ContinueSentinel;
      }

      if (info.done) {
        // Assign the result of the finished delegate to the temporary
        // variable specified by delegate.resultName (see delegateYield).
        context[delegate.resultName] = info.value; // Resume execution at the desired location (see delegateYield).

        context.next = delegate.nextLoc; // If context.method was "throw" but the delegate handled the
        // exception, let the outer generator proceed normally. If
        // context.method was "next", forget context.arg since it has been
        // "consumed" by the delegate iterator. If context.method was
        // "return", allow the original .return call to continue in the
        // outer generator.

        if (context.method !== "return") {
          context.method = "next";
          context.arg = undefined$1;
        }
      } else {
        // Re-yield the result returned by the delegate method.
        return info;
      } // The delegate iterator is finished, so forget it and continue with
      // the outer generator.


      context.delegate = null;
      return ContinueSentinel;
    } // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.


    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator"); // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.

    Gp[iteratorSymbol] = function () {
      return this;
    };

    Gp.toString = function () {
      return "[object Generator]";
    };

    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };

      if (1 in locs) {
        entry.catchLoc = locs[1];
      }

      if (2 in locs) {
        entry.finallyLoc = locs[2];
        entry.afterLoc = locs[3];
      }

      this.tryEntries.push(entry);
    }

    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal";
      delete record.arg;
      entry.completion = record;
    }

    function Context(tryLocsList) {
      // The root entry object (effectively a try statement without a catch
      // or a finally block) gives us a place to store values thrown from
      // locations where there is no enclosing try statement.
      this.tryEntries = [{
        tryLoc: "root"
      }];
      tryLocsList.forEach(pushTryEntry, this);
      this.reset(true);
    }

    exports.keys = function (object) {
      var keys = [];

      for (var key in object) {
        keys.push(key);
      }

      keys.reverse(); // Rather than returning an object with a next method, we keep
      // things simple and return the next function itself.

      return function next() {
        while (keys.length) {
          var key = keys.pop();

          if (key in object) {
            next.value = key;
            next.done = false;
            return next;
          }
        } // To avoid creating an additional object, we just hang the .value
        // and .done properties off the next function object itself. This
        // also ensures that the minifier will not anonymize the function.


        next.done = true;
        return next;
      };
    };

    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];

        if (iteratorMethod) {
          return iteratorMethod.call(iterable);
        }

        if (typeof iterable.next === "function") {
          return iterable;
        }

        if (!isNaN(iterable.length)) {
          var i = -1,
              next = function next() {
            while (++i < iterable.length) {
              if (hasOwn.call(iterable, i)) {
                next.value = iterable[i];
                next.done = false;
                return next;
              }
            }

            next.value = undefined$1;
            next.done = true;
            return next;
          };

          return next.next = next;
        }
      } // Return an iterator with no values.


      return {
        next: doneResult
      };
    }

    exports.values = values;

    function doneResult() {
      return {
        value: undefined$1,
        done: true
      };
    }

    Context.prototype = {
      constructor: Context,
      reset: function reset(skipTempReset) {
        this.prev = 0;
        this.next = 0; // Resetting context._sent for legacy support of Babel's
        // function.sent implementation.

        this.sent = this._sent = undefined$1;
        this.done = false;
        this.delegate = null;
        this.method = "next";
        this.arg = undefined$1;
        this.tryEntries.forEach(resetTryEntry);

        if (!skipTempReset) {
          for (var name in this) {
            // Not sure about the optimal order of these conditions:
            if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
              this[name] = undefined$1;
            }
          }
        }
      },
      stop: function stop() {
        this.done = true;
        var rootEntry = this.tryEntries[0];
        var rootRecord = rootEntry.completion;

        if (rootRecord.type === "throw") {
          throw rootRecord.arg;
        }

        return this.rval;
      },
      dispatchException: function dispatchException(exception) {
        if (this.done) {
          throw exception;
        }

        var context = this;

        function handle(loc, caught) {
          record.type = "throw";
          record.arg = exception;
          context.next = loc;

          if (caught) {
            // If the dispatched exception was caught by a catch block,
            // then let that catch block handle the exception normally.
            context.method = "next";
            context.arg = undefined$1;
          }

          return !!caught;
        }

        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          var record = entry.completion;

          if (entry.tryLoc === "root") {
            // Exception thrown outside of any try block that could handle
            // it, so set the completion value of the entire function to
            // throw the exception.
            return handle("end");
          }

          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc");
            var hasFinally = hasOwn.call(entry, "finallyLoc");

            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              } else if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) {
                return handle(entry.catchLoc, true);
              }
            } else if (hasFinally) {
              if (this.prev < entry.finallyLoc) {
                return handle(entry.finallyLoc);
              }
            } else {
              throw new Error("try statement without catch or finally");
            }
          }
        }
      },
      abrupt: function abrupt(type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }

        if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
          // Ignore the finally entry if control is not jumping to a
          // location outside the try/catch block.
          finallyEntry = null;
        }

        var record = finallyEntry ? finallyEntry.completion : {};
        record.type = type;
        record.arg = arg;

        if (finallyEntry) {
          this.method = "next";
          this.next = finallyEntry.finallyLoc;
          return ContinueSentinel;
        }

        return this.complete(record);
      },
      complete: function complete(record, afterLoc) {
        if (record.type === "throw") {
          throw record.arg;
        }

        if (record.type === "break" || record.type === "continue") {
          this.next = record.arg;
        } else if (record.type === "return") {
          this.rval = this.arg = record.arg;
          this.method = "return";
          this.next = "end";
        } else if (record.type === "normal" && afterLoc) {
          this.next = afterLoc;
        }

        return ContinueSentinel;
      },
      finish: function finish(finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.finallyLoc === finallyLoc) {
            this.complete(entry.completion, entry.afterLoc);
            resetTryEntry(entry);
            return ContinueSentinel;
          }
        }
      },
      "catch": function _catch(tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];

          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;

            if (record.type === "throw") {
              var thrown = record.arg;
              resetTryEntry(entry);
            }

            return thrown;
          }
        } // The context.catch method must only be called with a location
        // argument that corresponds to a known catch block.


        throw new Error("illegal catch attempt");
      },
      delegateYield: function delegateYield(iterable, resultName, nextLoc) {
        this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        };

        if (this.method === "next") {
          // Deliberately forget the last sent value so that we don't
          // accidentally pass it on to the delegate.
          this.arg = undefined$1;
        }

        return ContinueSentinel;
      }
    }; // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.

    return exports;
  }( // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports );

  try {
    regeneratorRuntime = runtime;
  } catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    Function("r", "regeneratorRuntime = r")(runtime);
  }
});

var RecommendationFlowEnum;

(function (RecommendationFlowEnum) {
  RecommendationFlowEnum["PDP"] = "PDP";
  RecommendationFlowEnum["Coveo"] = "Coveo";
})(RecommendationFlowEnum || (RecommendationFlowEnum = {}));

var types = {
  __proto__: null,
  get RecommendationFlowEnum () { return RecommendationFlowEnum; }
};

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') {
    return;
  }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".tr-personalized-recommendations .tr-PersonalizedRecommendations-wrapperCoveo {\n  font-family: knowledge2017, helvetica neue, arial, sans-serif;\n  font-family: knowledge2017, helvetica neue, arial, sans-serif;\n}\n\n.tr-personalized-recommendations .tr-PersonalizedRecommendations-wrapperPdp {\n  font-family: knowledge2017, helvetica neue, arial, sans-serif;\n  font-family: knowledge2017, helvetica neue, arial, sans-serif;\n}\n\n.tr-personalized-recommendations .tr-PersonalizedRecommendations-wrapperCoveo {\n  background-color: #fafafa;\n  background-color: #fafafa;\n}\n\n.tr-personalized-recommendations .tr-PersonalizedRecommendations-mainContainerCoveo {\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: flex;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  padding: 0 1.25rem 1.25rem 1.25rem;\n  padding: 0 1.25rem 1.25rem 1.25rem;\n}\n\n.tr-personalized-recommendations .tr-PersonalizedRecommendations-mainContainerPdp {\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: flex;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  padding: 0 1.25rem 1.25rem 1.25rem;\n  padding: 0 1.25rem 1.25rem 1.25rem;\n}\n\n.tr-personalized-recommendations .tr-PersonalizedRecommendations-mainContainerCoveo {\n  grid-gap: 0.5rem;\n  gap: 0.5rem;\n  grid-gap: 0.5rem;\n  gap: 0.5rem;\n  -ms-flex-pack: center;\n      justify-content: center;\n  padding: 0  0.9375rem 1.25rem;\n  padding: 0  0.9375rem 1.25rem;\n}\n\n.tr-personalized-recommendations .tr-PersonalizedRecommendations-mainContainerPdp {\n  grid-gap: 0.9375rem;\n  gap: 0.9375rem;\n  grid-gap: 0.9375rem;\n  gap: 0.9375rem;\n  -ms-flex-pack: center;\n      justify-content: center;\n  padding: 0 1.25rem 1.25rem 1.25rem;\n  padding: 0 1.25rem 1.25rem 1.25rem;\n}\n\n.tr-personalized-recommendations .tr-PersonalizedRecommendations-mainTitle {\n  font-weight: 500;\n  font-weight: 500;\n  margin-bottom: 16px;\n  margin-bottom: 1rem;\n  margin-top: 0;\n  margin-top: 0;\n  padding-top: 1.25rem;\n  padding-top: 1.25rem;\n  text-align: center;\n}\n\n.tr-personalized-recommendations .tr-PersonalizedRecommendation-container {\n  display: -ms-flexbox;\n  display: -webkit-box;\n  display: flex;\n  -ms-flex-direction: column;\n  flex-direction: column;\n}\n\n.tr-personalized-recommendations .tr-PersonalizedRecommendation-image {\n  margin-bottom: 0.75rem;\n  margin-bottom: 0.75rem;\n  width: 11.25rem;\n  width: 11.25rem;\n}\n\n.tr-personalized-recommendations .tr-PersonalizedRecommendations-mainContainerCoveo .tr-PersonalizedRecommendation-image {\n  height: 14rem;\n  height: 14rem;\n}\n\n.tr-personalized-recommendations .tr-PersonalizedRecommendations-mainContainerPdp .tr-PersonalizedRecommendation-image {\n  height: 15.255rem;\n  height: 15.255rem;\n}\n\n.tr-personalized-recommendations .tr-PersonalizedRecommendation-title {\n  color: #005da2;\n  color: #005da2;\n  font-size: 1.3125rem;\n  font-size: 1.3125rem;\n  font-weight: 700;\n  font-weight: 700;\n  margin-bottom: 0.25rem;\n  margin-bottom: 0.25rem;\n  text-decoration: none;\n  text-wrap: wrap;\n}\n\n.tr-personalized-recommendations .tr-PersonalizedRecommendations-mainContainerCoveo .tr-PersonalizedRecommendation-title {\n  font-size: 1.125rem;\n  font-size: 1.125rem;\n}\n\n.tr-personalized-recommendations .tr-PersonalizedRecommendations-mainContainerCoveo .tr-PersonalizedRecommendation-container {\n  width: 12.25rem;\n  width: 12.25rem;\n}\n\n.tr-personalized-recommendations .tr-PersonalizedRecommendations-mainContainerPdp .tr-PersonalizedRecommendation-title {\n  width: 14.938rem;\n  width: 14.938rem;\n}\n\n.tr-personalized-recommendations .tr-PersonalizedRecommendations-mainContainerPdp .tr-PersonalizedRecommendation-container {\n  width: 17.438rem;\n  width: 17.438rem;\n}\n\n.tr-personalized-recommendations .tr-PersonalizedRecommendation-title:visited {\n  color: #9647d1;\n  color: #9647d1;\n}\n\n@media (max-width: 767px) {\n  .tr-personalized-recommendations .tr-PersonalizedRecommendations-mainContainerCoveo {\n    -ms-flex-align: center;\n        align-items: center;\n    display: -ms-flexbox;\n    display: -webkit-box;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    padding: 1.25rem;\n    padding: 1.25rem;\n    width: auto;\n  }\n  .tr-personalized-recommendations .tr-PersonalizedRecommendations-mainContainerPdp {\n    -ms-flex-align: center;\n        align-items: center;\n    display: -ms-flexbox;\n    display: -webkit-box;\n    display: flex;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    padding: 1.25rem;\n    padding: 1.25rem;\n    width: auto;\n  }\n\n  .tr-personalized-recommendations .tr-PersonalizedRecommendation-authors {\n    margin-bottom: 1.25rem;\n    margin-bottom: 1.25rem;\n  }\n}\n";
styleInject(css_248z);

var recaptcha = {
  GET_RECOMMENDED_PRODUCTS: "RecommendedProducts"
};

var formatRecommendedProducts = function formatRecommendedProducts(recommendedProducts, productPagePath, defaultProductImagePath, analyticsQueryParams) {
  return recommendedProducts == null ? void 0 : recommendedProducts.map(function (recommendedProduct) {
    var _recommendedProduct$a;

    return {
      title: recommendedProduct == null ? void 0 : recommendedProduct.name,
      authors: recommendedProduct == null ? void 0 : (_recommendedProduct$a = recommendedProduct.authorDetails) == null ? void 0 : _recommendedProduct$a.map(function (author) {
        return author.authorName;
      }),
      productImageUrl: recommendedProduct == null ? void 0 : recommendedProduct.image,
      productUrl: "" + window.location.origin + productPagePath + (recommendedProduct == null ? void 0 : recommendedProduct.productTitle),
      description: recommendedProduct == null ? void 0 : recommendedProduct.description,
      defaultProductImageUrl: defaultProductImagePath,
      publishers: [],
      analyticsQueryParams: analyticsQueryParams
    };
  });
};
var getRecaptchaEnvVars = function getRecaptchaEnvVars(envVars) {
  var apigeeClientId = envVars.apigeeClientId,
      reCaptchaVerifyUrl = envVars.reCaptchaVerifyUrl,
      reCaptchaSiteKey = envVars.reCaptchaSiteKey;
  return {
    apiKey: apigeeClientId,
    reCaptchaVerifyUrl: reCaptchaVerifyUrl,
    reCaptchaSiteKey: reCaptchaSiteKey
  };
};
var fetchRecaptchaToken = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(envVars) {
    var recaptchaEnvVars, recaptchaToken;
    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            recaptchaEnvVars = getRecaptchaEnvVars(envVars);
            _context.next = 3;
            return getRecaptchaToken(recaptcha.GET_RECOMMENDED_PRODUCTS, recaptchaEnvVars);

          case 3:
            recaptchaToken = _context.sent;
            return _context.abrupt("return", recaptchaToken);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchRecaptchaToken(_x) {
    return _ref.apply(this, arguments);
  };
}();
var getClassName = function getClassName(_ref2) {
  var displayName = _ref2.displayName,
      descendantName = _ref2.descendantName;
  return "tr-" + displayName + "-" + descendantName;
};

var PersonalizedRecommendation = function PersonalizedRecommendation(props) {
  var productImageUrl = props.productImageUrl,
      productUrl = props.productUrl,
      authors = props.authors,
      description = props.description,
      defaultProductImageUrl = props.defaultProductImageUrl,
      altText = props.altText,
      _props$analyticsQuery = props.analyticsQueryParams,
      analyticsQueryParams = _props$analyticsQuery === void 0 ? "" : _props$analyticsQuery;
  var displayName = PersonalizedRecommendation.displayName;
  var personalizedRecommendationContainerCn = getClassName({
    displayName: displayName,
    descendantName: "container"
  });
  var personalizedRecommendationTitleCn = getClassName({
    displayName: displayName,
    descendantName: "title"
  });
  var personalizedRecommendationImageCn = getClassName({
    displayName: displayName,
    descendantName: "image"
  });
  var personalizedRecommendationAuthorsCn = getClassName({
    displayName: displayName,
    descendantName: "authors"
  });
  return React.createElement("div", {
    className: personalizedRecommendationContainerCn
  }, React.createElement("img", {
    src: productImageUrl || defaultProductImageUrl,
    className: personalizedRecommendationImageCn,
    alt: altText
  }), React.createElement("a", {
    href: productUrl + analyticsQueryParams,
    className: personalizedRecommendationTitleCn
  }, description), !!(authors != null && authors.length) && React.createElement("div", {
    className: personalizedRecommendationAuthorsCn
  }, authors == null ? void 0 : authors.map(function (name, index, authors) {
    return React.createElement("span", {
      key: name
    }, name, index !== authors.length - 1 && ", ");
  })));
};

PersonalizedRecommendation.displayName = "PersonalizedRecommendation";

var getRecommendedProducts = /*#__PURE__*/function () {
  var _ref = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee(envVars, productCode) {
    var apigeeUrl, apigeeClientId, apigeeProductRecommendationAPIEndPoint, url, options, recaptchaToken, response, errorEvent, data, _errorEvent;

    return runtime_1.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            apigeeUrl = envVars.apigeeUrl, apigeeClientId = envVars.apigeeClientId, apigeeProductRecommendationAPIEndPoint = envVars.apigeeProductRecommendationAPIEndPoint;
            url = apigeeUrl + "/" + apigeeProductRecommendationAPIEndPoint + "?productId=" + productCode + "&apiKey=" + apigeeClientId;
            options = {
              method: "GET"
            };
            _context.next = 5;
            return fetchRecaptchaToken(envVars);

          case 5:
            recaptchaToken = _context.sent;
            _context.prev = 6;
            _context.next = 9;
            return recaptchaAuthFetch({
              action: recaptcha.GET_RECOMMENDED_PRODUCTS,
              options: options,
              apiKey: apigeeClientId,
              serviceName: url,
              recaptchaToken: recaptchaToken
            });

          case 9:
            response = _context.sent;

            if (response.ok) {
              _context.next = 14;
              break;
            }

            errorEvent = new CustomEvent("recommendationResponseError", {
              detail: {
                message: response.statusText
              }
            });
            window.dispatchEvent(errorEvent);
            return _context.abrupt("return");

          case 14:
            _context.next = 16;
            return response.json();

          case 16:
            data = _context.sent;
            return _context.abrupt("return", data);

          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](6);
            _errorEvent = new CustomEvent("recommendationFetchError", {
              detail: {
                message: _context.t0
              }
            });
            window.dispatchEvent(_errorEvent);

          case 24:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 20]]);
  }));

  return function getRecommendedProducts(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

var PersonalizedRecommendations = function PersonalizedRecommendations(_ref) {
  var recommendedresults = _ref.recommendedresults,
      mode = _ref.mode,
      productrecommendationtitle = _ref.productrecommendationtitle,
      defaultproductimagepath = _ref.defaultproductimagepath,
      productrecommendationanalytics = _ref.productrecommendationanalytics,
      productcode = _ref.productcode,
      productpagepath = _ref.productpagepath;
  var displayName = PersonalizedRecommendations.displayName;

  var _useState = useState([]),
      recommendedProducts = _useState[0],
      setRecommendedProducts = _useState[1];

  var _useContext = useContext(EnvVariablesContext),
      envVariables = _useContext.envVariables;

  var fetchProducts = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/runtime_1.mark(function _callee() {
      var _response$recommended;

      var response, formattedRecommendedProducts;
      return runtime_1.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getRecommendedProducts(envVariables, productcode);

            case 2:
              response = _context.sent;
              formattedRecommendedProducts = formatRecommendedProducts(response == null ? void 0 : (_response$recommended = response.recommendedProductsResult[0]) == null ? void 0 : _response$recommended.recommendedProducts, productpagepath, defaultproductimagepath, productrecommendationanalytics);
              setRecommendedProducts(formattedRecommendedProducts);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchProducts() {
      return _ref2.apply(this, arguments);
    };
  }();

  useEffect(function () {
    if (mode === RecommendationFlowEnum.PDP && productcode && envVariables) {
      fetchProducts();
    } else if (mode === RecommendationFlowEnum.Coveo && recommendedresults) {
      setRecommendedProducts(recommendedresults);
    } //eslint-disable-next-line

  }, [recommendedresults, productcode, mode, envVariables]);
  var recommendedProductsWrapperCn = getClassName({
    displayName: displayName,
    descendantName: mode === RecommendationFlowEnum.PDP ? "wrapperPdp" : "wrapperCoveo"
  });
  var recommendedProductsMainContainerCn = getClassName({
    displayName: displayName,
    descendantName: mode === RecommendationFlowEnum.PDP ? "mainContainerPdp" : "mainContainerCoveo"
  });
  var recommendedProductsMainTitleCn = getClassName({
    displayName: displayName,
    descendantName: "mainTitle"
  });
  return React.createElement(React.Fragment, null, !!(recommendedProducts != null && recommendedProducts.length) && React.createElement("div", {
    className: "tr-personalized-recommendations"
  }, React.createElement("div", {
    className: recommendedProductsWrapperCn
  }, React.createElement("h2", {
    className: recommendedProductsMainTitleCn
  }, productrecommendationtitle), React.createElement("div", {
    className: recommendedProductsMainContainerCn
  }, recommendedProducts == null ? void 0 : recommendedProducts.map(function (product) {
    return React.createElement(PersonalizedRecommendation, Object.assign({}, product));
  })))));
};

PersonalizedRecommendations.displayName = "PersonalizedRecommendations";

var PersonalizedRecommendationsContainer = function PersonalizedRecommendationsContainer(_ref) {
  var recommendedresults = _ref.recommendedresults,
      mode = _ref.mode,
      productrecommendationtitle = _ref.productrecommendationtitle,
      defaultproductimagepath = _ref.defaultproductimagepath,
      productrecommendationanalytics = _ref.productrecommendationanalytics,
      productcode = _ref.productcode,
      productpagepath = _ref.productpagepath;
  return React.createElement(EnvVariablesProvider, null, React.createElement(PersonalizedRecommendations, {
    recommendedresults: recommendedresults,
    mode: mode,
    productrecommendationtitle: productrecommendationtitle,
    defaultproductimagepath: defaultproductimagepath,
    productrecommendationanalytics: productrecommendationanalytics,
    productcode: productcode,
    productpagepath: productpagepath
  }));
};

export { PersonalizedRecommendationsContainer as PersonalizedRecommendations, types as PersonalizedRecommendationsTypes };
//# sourceMappingURL=personalized-recommendations.esm.js.map
